import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import axiosInstance from 'helpers/axiosInstance';
import { QueryKeys } from '../QueryKeys';

export interface InsuranceDetails {
  id: string;
  payerId: string;
  payerName: string;
  groupId: string;
  memberId: string;
  relationToInsured: string;
  eligibilityResultDate: string;
  eligibilityResult: string;
  copayAmount: string;
  insurancePhone: string;
  insuranceMemberId: string;
  insuranceGroupId: string;
  insurancePayerId: string;
  sponsorName: string;
}

export interface InsuranceCoverageInfoResponse {
  insuranceDetails: InsuranceDetails[];
}

const useInsuranceCoverageInfo = (
  patientId?: string,
  extraOptions: UseQueryOptions<InsuranceDetails[]> = {},
) => {
  const enabled = !!patientId;
  const key = enabled ? QueryKeys.insuranceCoverage(patientId) : [];
  const url = `patients/patients/${patientId}/insurance_coverage`;

  return useQuery(
    key as QueryKey,
    () =>
      axiosInstance
        .get<InsuranceCoverageInfoResponse>(url)
        .then(r => r.data.insuranceDetails),
    {
      staleTime: Number.POSITIVE_INFINITY,
      enabled,
      ...extraOptions,
    },
  );
};

export default useInsuranceCoverageInfo;
